module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/wrapper-panels/ofset/ofset.component.scss
// module id = ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/wrapper-panels/ofset/ofset.component.scss
// module chunks = main